export default {
      id: "list-usage",
      viewBox: "0 0 21 14",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#list",
      toString: function () {
        return this.url;
      }
    }